<template>
  <div class="layout-with-centered-content">
    <div class="scroll-box">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutWithCenteredContent'
}
</script>

<style lang="scss">
  .layout-with-centered-content {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .scroll-box {
      position: relative;
      max-height: 100%;
      max-width: 100%;
      overflow: auto;
    }
  }
</style>
